import Axios from 'axios'
import { copyText, IClipboardData } from 'src/utils/clipboard'

import { asyncToast } from '../../app/toast'
import { appendParamsToUrl } from '../utils'

export async function copyToClipboardWithProvider(copyUrl: string, targetProvider: string) {
  const targetedUrl = appendParamsToUrl(copyUrl, { target_provider: targetProvider })
  const plainTextOnly = ['todoist', 'notion'].includes(targetProvider.toLocaleLowerCase())
  await copyToClipboard(targetedUrl, plainTextOnly)
}

export async function copyToClipboard(copyUrl: string, plainTextOnly: boolean): Promise<any> {
  const getPromise = Axios.get<IClipboardData>(copyUrl)
    .then((result) => result.data)
    .then((data) => {
      if (!data.plain_text && !data.html) {
        throw new Error('No data to copy')
      }

      return data
    })
  const copyPromise = copyText(getPromise, plainTextOnly)
  asyncToast(copyPromise, 'Copying…')
  return copyPromise
}
